import type { CSSProperties, ReactNode } from 'react';

export type KidsLoadingSize = 'small' | 'large' | number;

export interface KidsLoadingProps {
    /**
     * Size of the loading spinner
     * @default 'small'
     */
    size?: KidsLoadingSize;

    /**
     * Color of the spinning circle
     * @default primary color from theme
     */
    color?: string;

    /**
     * Icon to display in the center of the spinner
     * Can be a React component or node
     * If not provided, uses KidsPlaza logo from CDN
     */
    icon?: ReactNode;

    /**
     * Optional text to display below the spinner
     */
    text?: string;

    /**
     * Additional CSS classes for the container
     */
    className?: string;

    /**
     * Custom container style
     * When provided, the default loadingMask styles are not applied
     * This allows for inline/overlay positioning
     */
    containerStyle?: CSSProperties;

    /**
     * Test ID for testing
     */
    testID?: string;
}

export const KidsLoadingTestIDs = {
    loadingContainer: 'loading-container',
    loadingImage: 'loading-image',
    spinningCircle: 'spinning-circle',
};
